
var indexOf = [].indexOf;

module.exports = function(arr, obj){
  if (indexOf) return arr.indexOf(obj);
  for (var i = 0; i < arr.length; ++i) {
    if (arr[i] === obj) return i;
  }
  return -1;
};


//////////////////
// WEBPACK FOOTER
// /home/ingvars/BNC-Lab/front/~/indexof/index.js
// module id = ../../../../indexof/index.js
// module chunks = 3